import React, { useState } from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import { Image, TextButtonWithDropdownArrow } from 'newComponents'
import './styles.scss'

const customerQueries = graphql`
  query {
    ...CustomersFragment
  }
`

const CustomersBanner = () => {
  const [open, setOpen] = useState(false)
  const data = useStaticQuery(customerQueries)

  const setOpenHandler = () => {
    setOpen(!open)
  }

  const customerLogos = data.allCustomerLogosScrollJson.nodes.map((customer) => {
    const image = data.allFile.nodes.find((n) => n.name === customer.LogoColor).publicURL
    return (
      <div className="customer-logo-item" key={customer.name}>
        <Image image={image} alt={customer.name} className="customer-logo-image" />
      </div>
    )
  })

  return (
    <div className={`customer-banner-container ${open ? 'open' : 'close'}`}>
      <div className="customer-banner">
        <h2 className="customer-banner-heading">Powering 22 of Fortune 100 and Counting</h2>
        <div className="customer-banner-logos">{customerLogos}</div>
      </div>
      {/* <div className="customer-banner-see-more-teams">
        <a
          href="#customer-page-banner"
          onClick={setOpenHandler}
          className="customer-banner-action"
        >
          See{open ? ' Fewer ' : ' More '}Teams <DropdownArrow />
        </a>
      </div> */}
      <TextButtonWithDropdownArrow
        to="#customer-page-banner"
        onClick={setOpenHandler}
        text={`See ${open ? ' Fewer ' : ' More '}Teams`}
      />
    </div>
  )
}

export default CustomersBanner
